/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Navigate_TitleInputs */

const vi_qr_navigate_title = /** @type {(inputs: Qr_Navigate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR đơn hàng`)
};

/**

* @param {Qr_Navigate_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_navigate_title = /** @type {((inputs?: Qr_Navigate_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Navigate_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_navigate_title(inputs)
});